module.exports = __webpack_public_path__ + "img/footer-bg_xl.7cc1c20.webp";